import { baseApi } from "../baseApi";

export const categoryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createCategory: builder.mutation({
      query: (formData) => ({
        url: "/category-create",
        // url: "/category-create",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Category"],
    }),
    getCategories: builder.query({
      query: ({ page = 1,limit = 10,search = "",status = "",}={}) =>
        //  "/category-list",
         `/category-list?page=${page}&limit=${limit}&search=${search}&status=${status}`,
      
      providesTags: ["Category"],
    }),
    updateCategory: builder.mutation({
      query: ({ id, formData }) => ({
        url: `/category-edit/${id}`,
        method: "POST",
        body: formData,
      }),

      invalidatesTags: ["Category"],
    }),
    changeCategoryStatus: builder.mutation({
      query: (id) => ({
        url: `/category-status/${id}`,
        method: "GET",
      }),

      invalidatesTags: ["Category"],
    }),
    deleteCategory: builder.mutation({
      query: (data) => ({
        url: `/category-delete`,
        method: "DELETE",
        body:data
      }),


      invalidatesTags: ["Category"],
    }),

  }),
});

export const { useCreateCategoryMutation, useGetCategoriesQuery, useChangeCategoryStatusMutation, useUpdateCategoryMutation, useDeleteCategoryMutation, } = categoryApi;